export default __webpack_public_path__ + "static/media/3.14e3ceb0.jpg";